module.exports = __webpack_public_path__ + "static/roca-f36f7da8f07afbe23dd8f6f8f13912aa.eot";